/*
 * Given an ID, returns a FlyBase or CV data type/class.
 *
 */

export function typeFromId(id) {
  let dcIndex = id.indexOf(':') > 0 ? id.indexOf(':') : 4
  const type = id.substr(0, dcIndex)
  return type
}

export function getScaffoldFromLoc(location) {
  let i = location.indexOf(':')
  if (i === -1) {
    return location
  } else {
    return location.substr(0, i)
  }
}

export function getDcCounts(ids) {
  let dcCounts = {}
  for (const id of ids) {
    const type = typeFromId(id)
    if (type in dcCounts) {
      dcCounts[type]++
    } else {
      dcCounts[type] = 1
    }
  }
  return dcCounts
}
